export default "https://cdn-static.gokick.com/assets/6e728f413af15b4cc1be7e84aa96f9132e166160/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";